//lib
import React from "react";
import { Controller } from "react-hook-form";

//src
import AdditionalFormFields from "../common-type";
import DateTimePickerField from "./date-picker";
import { datePickerProps } from "./date-picker.type";
import dayjs from "dayjs";

export const DatePickerFormField = (props) => {
  const { name, defaultValue, control, isRequired, disabled } = props;

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <DateTimePickerField
            {...props}
            isRequired={isRequired}
            value={value}
            onChange={onChange}
            error={error}
            disabled={disabled}
          />
        );
      }}
    />
  );
};
DatePickerFormField.propTypes = {
  ...datePickerProps,
  ...AdditionalFormFields,
};

export default React.memo(DatePickerFormField);
